import { AccountDataInterface, ACCOUNT_DATA_READY, getDataEngineeringTrackers, RequestBody, updateCache, updateUIFromCache } from "@models/account-data";
import AccountDataService from "@services/account-data-service";
import { hasFileInSession, getFormUserDataFromSession } from "@utils/user_offer_storage";

interface Options {
  AccountDataRequestUrl: string;
}

/**
 * @deprecated Use the async version models/account-data.ts#getAccountData()
 */
export function deprecatedGetAccountData(): AccountDataInterface {
  return window._privateAccountData;
}

/**
 * Account Data
 * Get page data from DOM and meta elements and retrieve user data
 */
export default class AccountData {
  private service: AccountDataService;
  private ajaxloads: NodeListOf<HTMLElement>;
  private selectFile: HTMLElement;
  private smartapply: HTMLElement;
  private push: HTMLElement;
  private depotCV: HTMLElement;
  private company: HTMLElement;
  private response: NodeListOf<HTMLElement>;
  private requestData: RequestBody;

  constructor() {
    const accountDataOptionsJSON = document.getElementById('account-data-options');
    if (!accountDataOptionsJSON) {
      return;
    }
    const options:Options = JSON.parse(accountDataOptionsJSON.textContent);

    // Service used to retrieve account data
    this.service = new AccountDataService(options.AccountDataRequestUrl);

    // Data from page's DOM
    this.ajaxloads = document.querySelectorAll("[data-ajaxload=true]");
    this.selectFile =
      document.getElementById("Answer_FileId") ||
      document.querySelector("[data-postuler-serp]");
    this.smartapply = document.querySelector("[data-smartapply]");
    this.push = document.querySelector("[data-ajaxloadpushsubscribtion=true]");
    this.depotCV = document.querySelector("[data-depotcvoneclick]");
    this.company = document.querySelector("[data-companyid]");
    this.response = document.querySelectorAll("[data-typereponse]");

    // Data from page's meta
    this.requestData = {
      offerIds: [],
      track: getDataEngineeringTrackers()
    };

    updateUIFromCache()

    // Send request to get account data
    this.sendRequest();

    window.accountData = this
  }

  setData(selector: string, value: string, target: string) {
    document.querySelectorAll(selector).forEach((component: HTMLElement) => {
      (component as any)[target] = value;
    });
  }

  setDataById(selector: string, value: string, target: string) {
    const component = document.getElementById(selector);
    if (component) {
      (component as any)[target] = value;
    }
  }

  sendRequest () {
    // Set request parameters
    if (this.ajaxloads) {
      this.ajaxloads.forEach((ajaxLoad: HTMLElement) => {
        this.requestData.offerIds.push(ajaxLoad.dataset.offerid);
      });
    }
    this.requestData.loadEmail = true;
    if (this.selectFile) this.requestData.LoadListCv = true;
    if (this.smartapply) this.requestData.LoadSmartApplyCandidateInfo = true;
    if (this.push) this.requestData.LoadHasPushSubscription = true;
    if (this.depotCV) this.requestData.LoadDepotCvOneClick = true;
    if (this.company) this.requestData.CompanyId = this.company.dataset.companyid;
    if (this.response.length != 0) this.requestData.OfferTypeResponse = parseInt(
      this.response[0].getAttribute("data-typereponse")
    );

    // Retrieve the data
    this.service.post(this.requestData, this.handleResponse.bind(this));
  }

  handleResponse(data: AccountDataInterface) {
    window._privateAccountData = data
    // Tell LaStack that data is here
    PubSub.publish("account-data", data);

    // Tell async getAccountData that data is here
    document.dispatchEvent(new CustomEvent(ACCOUNT_DATA_READY));

    if (data.RoUrlWithFormIsActive) {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: "EventGenericNoHit",
        EventCat: "Formulaire",
        EventAction: "Load",
        EventLibelle: "UrlWithForm - Formulaire loadé" // TODO "loadé" >< Seriously WTF
      });
    }

    window.dataLayer.push({ Pays: data.CandidatPays });

    updateCache(data)
    updateUIFromCache()
    this.setInfos(data)
  }
  setInfos(data: AccountDataInterface):void {
    if(data.DisplayName) {
        this.setData(".displayname", data.DisplayName, "innerText");
    }
    if (data.LastName) {
        this.setData(".lastName", data.LastName, "innerText");
        this.setDataById("Answer_Name", data.LastName, "value");
        this.setDataById("CandidatureViewModel_Answer_Name", data.LastName, "value");
        this.setDataById("Name", data.LastName, "value");

    }
    if(data.FirstName) {
        this.setDataById("Answer_Firstname", data.FirstName, "value");
        this.setDataById("CandidatureViewModel_Answer_Firstname", data.FirstName, "value");
        this.setDataById("Firstname", data.FirstName, "value");

    }
    if(data.Email) {
        this.setData(".EmailCreationAlerte", data.Email, "value");
        this.setDataById("Email", data.Email, "value");
        this.setDataById("Email", "readonly", "readonly");
        this.setDataById("Answer_Email", data.Email, "value");
        this.setDataById("Answer_EmailConfirm", data.Email, "value");
        this.setDataById("EmailCandidat", data.Email, "innerText");
        this.setDataById("Answer_Email", "true", "readOnly");
        this.setDataById("CandidatureViewModel_Answer_Email", data.Email, "value");
        this.setDataById("CandidatureViewModel_Answer_Email", "true", "readOnly");
    }
    if (data.DepotCvOneClick){
        this.setDataById("Answer_DepotCvOneClick", data.DepotCvOneClick.toString(), "value");
    }
    const isCVTK = data.CvCvtk != null;
    const isCVRO = data.CvRo != null && data.CvRo.length > 0;
    if ((isCVTK || isCVRO) && document.getElementById("Answer_FileId")) {
        if(document.querySelectorAll('[data-serp-cv]').length > 0) {
            document.getElementById("ancreFileId").style.display = "flex";
        } else {
             document.getElementById("ancreFileId").style.display = "inline-block";
        }
        const option = document.createElement("optgroup") as HTMLOptionElement;
            option.appendChild(new Option("Sélectionner votre CV", "", true, true))
            this.selectFile.appendChild(option);
        if (isCVTK) {
                const optgroupCVTK = document.createElement("optgroup");
                optgroupCVTK.id = "cvtk";
                optgroupCVTK.label = "Votre CV Cvthèque";
                if(data.CvCvtk.LastUsed == true) {
                    optgroupCVTK.appendChild(new Option(data.CvCvtk.Name, data.CvCvtk.Id, true, true));
                } else {
                    optgroupCVTK.appendChild(new Option(data.CvCvtk.Name, data.CvCvtk.Id));
                }
                this.selectFile.appendChild(optgroupCVTK);
        }
        if (isCVRO) {
                const optgroupRO = option;
                optgroupRO.id = "cvro";

                // Find info in session
                const formUserData = getFormUserDataFromSession();
                if (formUserData) {
                  // File
                  data.CvRo.forEach(cv => cv.LastUsed = hasFileInSession(formUserData, cv.Hash));

                  // Cover Letter
                   const coverLetter = formUserData.coverLetter;
                  if (coverLetter) {
                      const textArea = <HTMLTextAreaElement>document.getElementById("Answer_Description");
                      const checkBoxDisplay = <HTMLInputElement>document.getElementById("Answer.Description_Button");
                      if (textArea && checkBoxDisplay) {
                        textArea.value = coverLetter;
                        checkBoxDisplay.checked = true;
                      }
                  }

                } 
                for (let cz = 0; cz < data.CvRo.length; cz++) {
                    if(data.CvRo[cz].LastUsed == true) {
                        optgroupRO.appendChild(new Option(data.CvRo[cz].Name, data.CvRo[cz].Id, true, true));
                    } else {
                        optgroupRO.appendChild(new Option(data.CvRo[cz].Name, data.CvRo[cz].Id));
                    }

                }
                this.selectFile.appendChild(optgroupRO);
        }
        PubSub.publish("add-list-cv");
        if (data.AccountInfo) {
            const info = data.AccountInfo;
            if(info.Address) this.setData('input[data-field="Address"]', info.Address, "value");
            if(info.City) this.setData('input[data-field="City"]', info.City, "value");
            if(info.PhoneNumber) this.setData('input[data-field="PhoneNumber"]', info.PhoneNumber, "value");
            if(info.PostalCode) this.setData('input[data-field="PostalCode"]', info.PostalCode, "value");
        }

    }
    PubSub.publish("account-data-ready");

  }
}
